import { NgIf } from '@angular/common';
import { Directive, OnInit, inject } from '@angular/core';
import { App } from '@df/core/app';

/**
 * Use this directive to present element only when platform is browser
 *
 * ```html
 * <div *ifBrowser>...</div>
 * ```
 */
@Directive({
    selector: '[ifBrowser]',
    standalone: true
})
export class IfBrowserDirective extends NgIf implements OnInit {
    private app = inject(App);

    /**
     * Sets condition depending on user being developer.
     *
     * @memberof IfBrowserDirective
     */
    ngOnInit() {
        this.ngIf = this.app.isPlatformBrowser;
    }
}
